// extracted by mini-css-extract-plugin
export default {"primaryText":"Ideas_primaryText__wEsS9","secondaryText":"Ideas_secondaryText__AeZoZ"};